export type ProgressState = 'done' | 'active' | 'pending';

export interface ProgressTrackerStep {
  label: string;
  state: ProgressState;
  /** When set, the step becomes a navigation button that opens that part of the flow. */
  onSelect?: () => void;
}

export default function ProgressTracker({
  steps,
  ariaLabel = 'Progress',
  className = '',
}: {
  steps: ProgressTrackerStep[];
  ariaLabel?: string;
  className?: string;
}) {
  return (
    <ol className={`tracker ${className}`.trim()} aria-label={ariaLabel}>
      {steps.map((step, index) => {
        const nodeClass = `tracker-node ${
          step.state === 'done'
            ? 'tracker-node-done'
            : step.state === 'active'
              ? 'tracker-node-active'
              : ''
        }`.trim();
        const current = step.state === 'active' ? 'step' : undefined;
        const content = (
          <>
            <span className="tracker-bubble">{step.state === 'done' ? '✓' : index + 1}</span>
            <span className="tracker-label">{step.label}</span>
          </>
        );
        return (
          <li className="contents" key={`${step.label}-${index}`}>
            {index > 0 ? (
              <span
                className={`tracker-bar ${step.state === 'pending' ? '' : 'tracker-bar-done'}`.trim()}
                aria-hidden="true"
              />
            ) : null}
            {step.onSelect ? (
              <button
                type="button"
                className={`${nodeClass} tracker-node-button`}
                onClick={step.onSelect}
                aria-current={current}
              >
                {content}
              </button>
            ) : (
              <span className={nodeClass} aria-current={current}>{content}</span>
            )}
          </li>
        );
      })}
    </ol>
  );
}
